import styles from '../styles/Header.module.css'

export default function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src="/assets/Sublogo/PNG/SUBLOGO corte.png"
            alt="Sublogo"
            width={150}
          />
        </div>
        <div className={styles.slogan}>
          <span className="gray-text">Paulo Ferreira &</span> Maike Ramos
        </div>
        <a
          href="https://tintim.link/whatsapp/f29b407c-6594-4bba-b0aa-f5442f711a68/e7405481-419a-4fdb-8030-9aee45f67a3a"
          target="_blank"
          rel="noreferrer"
          className={`${styles.cta} whatsapp-btn`}
        >
          <i className="fab fa-whatsapp"></i> Agendar Consulta
        </a>
      </div>
      
      {/* Adicionando estilos inline para o botão do WhatsApp */}
      <style jsx>{`
        .whatsapp-btn {
          background-color: #25D366 !important;
          color: white !important;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
        }
        
        .whatsapp-btn:hover {
          box-shadow: 0 8px 20px rgba(37, 211, 102, 0.4) !important;
          transform: translateY(-3px);
        }
      `}</style>
    </header>
  )
}